import { siteInfo } from '@/mocks/site';
import { categories } from '@/mocks/articles';

/* ---- Shared: Organization ---- */
export function OrganizationSchema() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: typeof window !== 'undefined' ? 'http://sxthpxzx.cn' : '',
    description: siteInfo.description,
    email: siteInfo.email,
    foundingDate: siteInfo.foundedYear,
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: siteInfo.email,
      availableLanguage: 'Chinese',
    },
  };
  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
  );
}

/* ---- Shared: WebSite ---- */
export function WebSiteSchema() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: typeof window !== 'undefined' ? 'http://sxthpxzx.cn' : '',
    description: siteInfo.description,
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${typeof window !== 'undefined' ? 'http://sxthpxzx.cn' : ''}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };
  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
  );
}

/* ---- WebPage ---- */
export function WebPageSchema({
  title,
  description,
  url,
  datePublished,
  dateModified,
}: {
  title: string;
  description: string;
  url: string;
  datePublished?: string;
  dateModified?: string;
}) {
  const schema: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description,
    url,
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: siteInfo.name,
      url: typeof window !== 'undefined' ? 'http://sxthpxzx.cn' : '',
    },
  };
  if (datePublished) schema.datePublished = datePublished;
  if (dateModified) schema.dateModified = dateModified;
  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
  );
}

/* ---- BreadcrumbList ---- */
export function BreadcrumbListSchema({
  items,
}: {
  items: { name: string; url: string }[];
}) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
  );
}

/* ---- Article ---- */
export function ArticleSchema({
  headline,
  description,
  url,
  image,
  datePublished,
  dateModified,
  authorName,
}: {
  headline: string;
  description: string;
  url: string;
  image: string;
  datePublished: string;
  dateModified?: string;
  authorName?: string;
}) {
  const schema: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
    description,
    url,
    image,
    datePublished,
    author: {
      '@type': 'Organization',
      name: authorName || siteInfo.name,
      url: typeof window !== 'undefined' ? 'http://sxthpxzx.cn' : '',
    },
    publisher: {
      '@type': 'Organization',
      name: siteInfo.name,
      url: typeof window !== 'undefined' ? 'http://sxthpxzx.cn' : '',
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
  };
  if (dateModified) schema.dateModified = dateModified;
  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
  );
}

/* ---- FAQPage ---- */
export function FAQPageSchema({
  questions,
}: {
  questions: { question: string; answer: string }[];
}) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: questions.map((q) => ({
      '@type': 'Question',
      name: q.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: q.answer,
      },
    })),
  };
  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
  );
}

/* ---- CollectionPage (for category pages) ---- */
export function CollectionPageSchema({
  name,
  description,
  url,
}: {
  name: string;
  description: string;
  url: string;
}) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name,
    description,
    url,
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: siteInfo.name,
      url: typeof window !== 'undefined' ? 'http://sxthpxzx.cn' : '',
    },
  };
  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
  );
}

/* ---- Homepage FAQ data ---- */
export const homepageFaqs = [
  {
    question: '吃瓜群众是什么意思？',
    answer: '吃瓜群众是网络流行语，指在网络上围观八卦、爆料等事件的普通网友，以"吃瓜"比喻抱着看热闹的心态关注事态发展的行为。吃瓜群为吃瓜群众提供免费吃瓜与在线爆料平台，每日更新最新网红塌房、明星黑料等热门吃瓜内容。',
  },
  {
    question: '吃瓜群众的瓜是什么瓜？',
    answer: '"瓜"在网络用语中指八卦、爆料、内幕消息。吃瓜群众的"瓜"不是真的水果，而是指娱乐圈、网红圈的各种劲爆新闻和未公开的内幕信息。吃瓜群官网每日实时追踪最新黑料大瓜，包括网红塌房、博主反差视频、明星聊天记录泄露等。',
  },
  {
    question: 'qq吃瓜群怎么加入？',
    answer: '在吃瓜群官网首页或文章页面都有QQ吃瓜群入口，点击"加入QQ吃瓜群"按钮即可跳转到QQ群。加入群聊后可实时接收最新黑料推送，与其他吃瓜群众一起讨论热门爆料事件。',
  },
  {
    question: '吃瓜群上的爆料内容真实吗？',
    answer: '吃瓜群坚持真实爆料、拒绝谣言的原则。每一条爆料都经过多方信息交叉核实，编辑团队由资深娱乐记者和自媒体人组成。但我们仍提醒广大吃瓜群众理性吃瓜，对于尚未充分证实的消息保持审慎态度。',
  },
  {
    question: '如何在吃瓜群投稿爆料？',
    answer: '如果你有第一手内幕信息想爆料，可以通过吃瓜群官网上的爆料邮箱（hello@sxthpxzx.cn）发送邮件投稿，或在QQ吃瓜群内联系管理员。我们会保护爆料人的隐私信息。',
  },
];